import { UserService } from '@/retail/contexts/customers/services/user.service'

export const userService = new UserService()
